<script>
    import Button from "./Button.svelte";
    import Checkbox from "../../Common/Checkbox.svelte";
    import {M} from "../../external";

    export let data;
</script>

<Checkbox bind:data={data.switched} label={M.SWITCH_SIDE} clz="popup-input-wrapper mt-5 mb-10"/>
<Button bind:data={data}/>
